import "../css/footer.css";
import { Link } from "react-router-dom";
import big_logo_long_white from "../img/big_logo_long_white.png";

const Footer = () => {
  return (
    <footer>
      <div id="footer_logo">
        <Link to="/">
          <img src={big_logo_long_white} alt="big_logo_long.png" />
        </Link>
      </div>
      <div id="footer_menu">
        <Link class="footer_link" to="/about">
          About
        </Link>
        <Link class="footer_link" to="/documentation">
          Documentation
        </Link>
        <a class="footer_link" href="https://github.com/tomcreigh/CheatSheet">
          GitHub
        </a>
        <a class="footer_link" href="#">
          Download
        </a>
      </div>
    </footer>
  );
};

export default Footer;
